<template id="page-top">
  <notifications position="top center" />
  <vue3-confirm-dialog></vue3-confirm-dialog>
  <div id="wrapper">
    <menuLeft v-if="!$route.meta.hideMenu" ></menuLeft>
    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <menuTop v-if="!$route.meta.hideMenu"></menuTop>
        <router-view />
      </div>
      <descriptionFooter></descriptionFooter>
    </div>
    <SupportChat v-if="support == 'true'"></SupportChat>
  </div>
 <WhatsappButton v-if="whatsapp == 'true'" :phone="whatsapp_number"
    message="Olá, preciso de ajuda na minha área do cliente..." />
</template>

<script>
import menuLeft from './components/menu/menu-left.vue'
import menuTop from '@/components/menu/menu-top.vue'
import descriptionFooter from '@/components/footer/description-footer.vue'
import SupportChat from '@/components/support/support-chat.vue'
import WhatsappButton from '@/components/WhatsappButton.vue'

export default {
  name: 'App',
  components: { menuLeft, menuTop, descriptionFooter, SupportChat, 	WhatsappButton	},
  data() {
    return {
      support: false,
      whatsapp:false,
      whatsapp_number:'',
      client_id:'',
    }
  },
  mounted() {
    this.support = process.env.VUE_APP_SUPPORT;
    this.whatsapp = process.env.VUE_APP_WHATSAPP;
    this.whatsapp_number = process.env.VUE_APP_WHATSAPP_NUMBER;
  }
}



</script>

<style></style>
